// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpSecondaryTabAceptarTodoGuardar} from "./secondary_tab/aceptar_todo_guardar";
import {TraduccionCmpSecondaryTabAceptarTodo} from "./secondary_tab/aceptar_todo";
import {TraduccionCmpSecondaryTabAceptar} from "./secondary_tab/aceptar";
import {TraduccionCmpSecondaryTabCmpAlmacenaInfo} from "./secondary_tab/cmp_almacena_info";
import {TraduccionCmpSecondaryTabCmpCaracteristicas} from "./secondary_tab/cmp_caracteristicas";
import {TraduccionCmpSecondaryTabCmpCaractsEspec} from "./secondary_tab/cmp_caracts_espec";
import {TraduccionCmpSecondaryTabCmpConsentExplTitulo} from "./secondary_tab/cmp_consent_expl_titulo";
import {TraduccionCmpSecondaryTabCmpConsentLiTitulo} from "./secondary_tab/cmp_consent_li_titulo";
import {TraduccionCmpSecondaryTabCmpCookiesAlmacena1} from "./secondary_tab/cmp_cookies_almacena_1";
import {TraduccionCmpSecondaryTabCmpCookiesAlmacena2} from "./secondary_tab/cmp_cookies_almacena_2";
import {TraduccionCmpSecondaryTabCmpDataDeclarationsTitulo} from "./secondary_tab/cmp_data_declarations_titulo";
import {TraduccionCmpSecondaryTabCmpDataRetentionInfo, TraduccionCmpSecondaryTabCmpDataRetentionInfoParams} from "./secondary_tab/cmp_data_retention_info";
import {TraduccionCmpSecondaryTabCmpDataRetentionTitulo} from "./secondary_tab/cmp_data_retention_titulo";
import {TraduccionCmpSecondaryTabCmpEmpNoIabTitulo} from "./secondary_tab/cmp_emp_no_iab_titulo";
import {TraduccionCmpSecondaryTabCmpEmpresas} from "./secondary_tab/cmp_empresas";
import {TraduccionCmpSecondaryTabCmpLegIntClaim} from "./secondary_tab/cmp_leg_int_claim";
import {TraduccionCmpSecondaryTabCmpProposCaracts} from "./secondary_tab/cmp_propos_caracts";
import {TraduccionCmpSecondaryTabCmpProposEspec} from "./secondary_tab/cmp_propos_espec";
import {TraduccionCmpSecondaryTabCmpProposLi} from "./secondary_tab/cmp_propos_li";
import {TraduccionCmpSecondaryTabCmpPropositos} from "./secondary_tab/cmp_propositos";
import {TraduccionCmpSecondaryTabCmpTiempoAlmacena} from "./secondary_tab/cmp_tiempo_almacena";
import {TraduccionCmpSecondaryTabDominio} from "./secondary_tab/dominio";
import {TraduccionCmpSecondaryTabGdprDatosFinalidadCmp2} from "./secondary_tab/gdpr_datos_finalidad_cmp2";
import {TraduccionCmpSecondaryTabGdprListaSocios} from "./secondary_tab/gdpr_lista_socios";
import {TraduccionCmpSecondaryTabGuardarCerrar} from "./secondary_tab/guardar_cerrar";
import {TraduccionCmpSecondaryTabMasInformacion} from "./secondary_tab/mas_informacion";
import {TraduccionCmpSecondaryTabObligatorio} from "./secondary_tab/obligatorio";
import {TraduccionCmpSecondaryTabPoliticaDePrivacidad} from "./secondary_tab/politica_de_privacidad";
import {TraduccionCmpSecondaryTabRechazarTodo} from "./secondary_tab/rechazar_todo";
import {TraduccionCmpSecondaryTabRechazar} from "./secondary_tab/rechazar";
import {TraduccionCmpSecondaryTabTextoPrincipalCmp2} from "./secondary_tab/texto_principal_cmp2";
import {TraduccionCmpSecondaryTabVolver} from "./secondary_tab/volver";

export class TraduccionCmpSecondaryTab extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.secondary_tab";
    // public static VERSION: Date = new Date("2023-10-09T05:37:38.885Z");
    // public static HASH: string = "88502044ff74bec1ec08f9bd48a5f034";

    private static CACHE: {[lang: string]: TraduccionCmpSecondaryTab} = {};

    public static build(lang: IIdioma): TraduccionCmpSecondaryTab {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public aceptar: string;
    public aceptar_todo: string;
    public aceptar_todo_guardar: string;
    public cmp_almacena_info: string;
    public cmp_caracteristicas: string;
    public cmp_caracts_espec: string;
    public cmp_consent_expl_titulo: string;
    public cmp_consent_li_titulo: string;
    public cmp_cookies_almacena_1: string;
    public cmp_cookies_almacena_2: string;
    public cmp_data_declarations_titulo: string;
    public cmp_data_retention_titulo: string;
    public cmp_emp_no_iab_titulo: string;
    public cmp_empresas: string;
    public cmp_leg_int_claim: string;
    public cmp_propos_caracts: string;
    public cmp_propos_espec: string;
    public cmp_propos_li: string;
    public cmp_propositos: string;
    public cmp_tiempo_almacena: string;
    public dominio: string;
    public gdpr_datos_finalidad_cmp2: string;
    public gdpr_lista_socios: string;
    public guardar_cerrar: string;
    public mas_informacion: string;
    public obligatorio: string;
    public politica_de_privacidad: string;
    public rechazar: string;
    public rechazar_todo: string;
    public texto_principal_cmp2: string;
    public volver: string;

    #cmp_data_retention_info: TraduccionCmpSecondaryTabCmpDataRetentionInfo;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.aceptar = TraduccionCmpSecondaryTabAceptar.build(this._lang).toString();
        this.aceptar_todo = TraduccionCmpSecondaryTabAceptarTodo.build(this._lang).toString();
        this.aceptar_todo_guardar = TraduccionCmpSecondaryTabAceptarTodoGuardar.build(this._lang).toString();
        this.cmp_almacena_info = TraduccionCmpSecondaryTabCmpAlmacenaInfo.build(this._lang).toString();
        this.cmp_caracteristicas = TraduccionCmpSecondaryTabCmpCaracteristicas.build(this._lang).toString();
        this.cmp_caracts_espec = TraduccionCmpSecondaryTabCmpCaractsEspec.build(this._lang).toString();
        this.cmp_consent_expl_titulo = TraduccionCmpSecondaryTabCmpConsentExplTitulo.build(this._lang).toString();
        this.cmp_consent_li_titulo = TraduccionCmpSecondaryTabCmpConsentLiTitulo.build(this._lang).toString();
        this.cmp_cookies_almacena_1 = TraduccionCmpSecondaryTabCmpCookiesAlmacena1.build(this._lang).toString();
        this.cmp_cookies_almacena_2 = TraduccionCmpSecondaryTabCmpCookiesAlmacena2.build(this._lang).toString();
        this.cmp_data_declarations_titulo = TraduccionCmpSecondaryTabCmpDataDeclarationsTitulo.build(this._lang).toString();
        this.#cmp_data_retention_info = TraduccionCmpSecondaryTabCmpDataRetentionInfo.build(this._lang);
        this.cmp_data_retention_titulo = TraduccionCmpSecondaryTabCmpDataRetentionTitulo.build(this._lang).toString();
        this.cmp_emp_no_iab_titulo = TraduccionCmpSecondaryTabCmpEmpNoIabTitulo.build(this._lang).toString();
        this.cmp_empresas = TraduccionCmpSecondaryTabCmpEmpresas.build(this._lang).toString();
        this.cmp_leg_int_claim = TraduccionCmpSecondaryTabCmpLegIntClaim.build(this._lang).toString();
        this.cmp_propos_caracts = TraduccionCmpSecondaryTabCmpProposCaracts.build(this._lang).toString();
        this.cmp_propos_espec = TraduccionCmpSecondaryTabCmpProposEspec.build(this._lang).toString();
        this.cmp_propos_li = TraduccionCmpSecondaryTabCmpProposLi.build(this._lang).toString();
        this.cmp_propositos = TraduccionCmpSecondaryTabCmpPropositos.build(this._lang).toString();
        this.cmp_tiempo_almacena = TraduccionCmpSecondaryTabCmpTiempoAlmacena.build(this._lang).toString();
        this.dominio = TraduccionCmpSecondaryTabDominio.build(this._lang).toString();
        this.gdpr_datos_finalidad_cmp2 = TraduccionCmpSecondaryTabGdprDatosFinalidadCmp2.build(this._lang).toString();
        this.gdpr_lista_socios = TraduccionCmpSecondaryTabGdprListaSocios.build(this._lang).toString();
        this.guardar_cerrar = TraduccionCmpSecondaryTabGuardarCerrar.build(this._lang).toString();
        this.mas_informacion = TraduccionCmpSecondaryTabMasInformacion.build(this._lang).toString();
        this.obligatorio = TraduccionCmpSecondaryTabObligatorio.build(this._lang).toString();
        this.politica_de_privacidad = TraduccionCmpSecondaryTabPoliticaDePrivacidad.build(this._lang).toString();
        this.rechazar = TraduccionCmpSecondaryTabRechazar.build(this._lang).toString();
        this.rechazar_todo = TraduccionCmpSecondaryTabRechazarTodo.build(this._lang).toString();
        this.texto_principal_cmp2 = TraduccionCmpSecondaryTabTextoPrincipalCmp2.build(this._lang).toString();
        this.volver = TraduccionCmpSecondaryTabVolver.build(this._lang).toString();
    }

    public cmp_data_retention_info(params: Partial<TraduccionCmpSecondaryTabCmpDataRetentionInfoParams> = {}) {
        return this.#cmp_data_retention_info.render(params);
    }
}

export default (lang: IIdioma)=>TraduccionCmpSecondaryTab.build(lang);
